'use client';

import { Chat } from './chat';
import { FullscreenModal } from './components/fullscreen-modal';
import { ChatProvider } from './context/chat-context';

export function ChatPage() {
  return (
    <ChatProvider>
      <Chat />
      <FullscreenModal />
    </ChatProvider>
  );
}
